module.exports = "/assets/8862254dda509984b65381672c48b2c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YS.png
// module id = 2041
// module chunks = 0